<div class="row mt-2">
  <div class="pl-3">
    <p (click)="content.toggle(); collapseEvent.emit(content.isCollapsed)" class="mouse-pointer mb-0">
      <jhi-bary-icon *ngIf="!withArrow && content.isCollapsed" icon="plus" [faDirective]="FAS" class="pr-1"></jhi-bary-icon>
      <jhi-bary-icon *ngIf="!withArrow && !content.isCollapsed" icon="minus" [faDirective]="FAS" class="pr-1"></jhi-bary-icon>
      <a onclick="return false;">
        <span onclick="return false;" class="default" [class.text-gray]="!withArrow">{{ label }}</span>
      </a>
      <jhi-bary-icon *ngIf="withArrow && content.isCollapsed" icon="angle-down" [faDirective]="FAS" class="pl-1"></jhi-bary-icon>
      <jhi-bary-icon *ngIf="withArrow && !content.isCollapsed" icon="angle-up" [faDirective]="FAS" class="pl-1"></jhi-bary-icon>
    </p>
  </div>
</div>

<div class="" mdbCollapse [isCollapsed]="isCollapsed" #content="bs-collapse">
  <ng-content></ng-content>
</div>
